const NoResultsIcon = ({ className, style }: { className?: string; style?: any }) => {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <g clipPath="url(#clip0_1522_25372)">
        <circle cx="60" cy="60" r="60" fill="#F6F6F6" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M63.3585 27.8947C61.1742 27.1943 58.8255 27.1943 56.6412 27.8947L32.6832 35.58C31.8235 35.8599 31.0974 36.4475 30.6445 37.23L22.4422 51.398C22.1679 51.872 22.0033 52.4015 21.9605 52.9474C21.9176 53.4934 21.9976 54.042 22.1945 54.553C22.3915 55.064 22.7004 55.5244 23.0986 55.9004C23.4967 56.2763 23.9741 56.5584 24.4955 56.7257L50.6755 65.1297C51.4725 65.3855 52.333 65.361 53.114 65.0601C53.8951 64.7593 54.5497 64.2003 54.9692 63.476L56.3332 61.122V69.6177C56.3332 70.1953 56.1967 70.7648 55.9348 71.2797C55.673 71.7946 55.2932 72.2403 54.8264 72.5806C54.3596 72.9208 53.819 73.146 53.2487 73.2377C52.6784 73.3294 52.0945 73.2851 51.5445 73.1084L30.1385 66.2407V78.26C30.1378 79.8132 30.6303 81.3266 31.5449 82.5819C32.4596 83.8372 33.7492 84.7697 35.2279 85.245L56.6412 92.109C58.8255 92.8094 61.1742 92.8094 63.3585 92.109L84.7719 85.245C86.2513 84.7704 87.5417 83.8381 88.457 82.5827C89.3724 81.3274 89.8653 79.8137 89.8649 78.26L89.8575 66.2407L68.4552 73.1084C67.905 73.2852 67.3207 73.3295 66.7501 73.2376C66.1795 73.1457 65.6387 72.9202 65.1719 72.5795C64.705 72.2388 64.3253 71.7926 64.0637 71.2772C63.802 70.7619 63.666 70.192 63.6665 69.614V61.1184L65.0269 63.4724C65.4469 64.196 66.1018 64.7542 66.8828 65.0544C67.6638 65.3545 68.524 65.3785 69.3205 65.1224L95.5042 56.7257C96.0262 56.5585 96.504 56.2764 96.9026 55.9001C97.3012 55.5239 97.6103 55.0631 97.8073 54.5516C98.0043 54.0402 98.0841 53.491 98.0409 52.9446C97.9977 52.3982 97.8325 51.8685 97.5575 51.3944L89.3552 37.23C88.9023 36.4475 88.1763 35.8599 87.3165 35.58L63.3585 27.8947ZM74.1862 39.0707L59.9999 43.621L45.8099 39.0707L58.8779 34.876C59.6064 34.6423 60.3897 34.6423 61.1182 34.876L74.1862 39.0707Z"
          fill="#DAD9D9"
        />
      </g>
      <defs>
        <clipPath id="clip0_1522_25372">
          <rect width="120" height="120" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NoResultsIcon;
